type PromiseWithResolvers<T> = {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
};

type PromiseConstructorWithResolvers = PromiseConstructor & {
  withResolvers?: <T>() => PromiseWithResolvers<T>;
};

/** Polyfill for environments without ES2024 Promise.withResolvers (e.g. older Android WebView). */
export function applyPromiseWithResolversPolyfill(
  target: { Promise?: PromiseConstructor } = globalThis
): void {
  const PromiseRef = target.Promise as
    | PromiseConstructorWithResolvers
    | undefined;
  if (!PromiseRef || PromiseRef.withResolvers) {
    return;
  }

  PromiseRef.withResolvers = function withResolvers<T>(): PromiseWithResolvers<T> {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new PromiseRef<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

applyPromiseWithResolversPolyfill();
